import { render, staticRenderFns } from "./PowerDetailsChart.vue?vue&type=template&id=40cd5ff8&"
import script from "./PowerDetailsChart.vue?vue&type=script&lang=js&"
export * from "./PowerDetailsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PowerDetailsChart.vue?vue&type=custom&index=0&blockType=i18n&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports